import mobileDetect from 'mobile-detect';
const md = new mobileDetect(window.navigator.userAgent);

export const isMobile = () => !!md.mobile() && !md.tablet();
export const isApple = () => md.is('iPhone');
export const isAndroid = () => isMobile() && !isApple();
